import { memo } from "react";
import Button from "components/Elements/Button/Button";
import useMediaQueries from "hooks/useMediaQueries";
import AddSubUserModal from "./Modals/AddSubUserModal";
import BeforePurchaseModal from "./Modals/BeforePurchaseModal";
import Icon from "components/Elements/Icon/Icon";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import { useUser } from "contexts/userContext/userContext";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";

const InviteSubUserButton = memo(() => {
  const { mobileCondition, largeDesktopCondition, tabletCondition } =
    useMediaQueries();
  const { getUserData } = useUser();
  const { setModal } = useModal();
  const { getTextByKey } = useContent();

  const openAddUserModal = () => {
    setModal(() => <AddSubUserModal />);
  };

  const openBeforePurchaseNewSubUserLicenses = () => {
    setModal(() => <BeforePurchaseModal userData={getUserData()} />);
  };

  return (
    /*@ts-ignore*/
    <div className="insert-new-user">
      <Tooltip tooltipTextKey={getTextByKey("add-sub-user")}>
        <Button
          medium
          className={`insert-new-user-button ${
            mobileCondition || tabletCondition ? "mobile" : ""
          }`}
          onClick={() =>
            getUserData().UserAvailableSubUsersLicenses === 0
              ? openBeforePurchaseNewSubUserLicenses()
              : openAddUserModal()
          }
        >
          <Icon
            iconClass={`insert-new-user-icon ${
              mobileCondition || tabletCondition ? "mobile" : ""
            }`}
            name="user-plus"
            large
            alt="invite sub user"
          />
          <span>{largeDesktopCondition && getTextByKey("add-sub-user")}</span>
        </Button>
      </Tooltip>
    </div>
  );
});

export default InviteSubUserButton;
